import { Head, Link } from '@inertiajs/react'
import { ChevronLeft } from 'lucide-react'
import DashboardLayout from '@/frontend/layouts/DashboardLayout'
import DashboardWorkbench from '@/frontend/features/DashboardRuntime/DashboardWorkbench'
import PublicationAccess from '@/frontend/features/DashboardRuntime/PublicationAccess'
import { usePublication } from '@/frontend/features/DashboardRuntime/usePublication'
import type { Copy, Publication, ViewHistory } from '@/frontend/features/DashboardRuntime/types'
import PublicationByline from '@/frontend/features/DashboardRuntime/PublicationByline'
import { useWorkstationPageContext } from '@/frontend/features/AgentChats/workstationPageContext'

function Show(props: { project: { id: string; name: string }; publication: Publication; copy: Copy; can_manage: boolean; viewer_ids: number[]; viewers: { id: number; name: string }[]; selected_view?: string; view_history?: ViewHistory; chat_worker_ids?: string[] }) {
  const path = `/dashboard/projects/${props.project.id}/dashboards/${props.publication.id}`
  const { publication, denied } = usePublication(props.publication, path)
  const { copy } = props
  useWorkstationPageContext('dashboard-runtime-project', { project: { id: props.project.id, chat_worker_ids: props.chat_worker_ids ?? [] } })
  return <main className="flex h-full min-h-0 flex-col bg-background">
    <Head title={publication.title} />
    <header className="flex shrink-0 items-start gap-3 border-b px-4 py-3 md:px-6">
      <div className="min-w-0 flex-1 space-y-1.5">
        <Link href={`/dashboard/projects/${props.project.id}/dashboards`} className="inline-flex max-w-full items-center gap-1 text-xs text-muted-foreground transition-colors hover:text-foreground" aria-label={copy.back}>
          <ChevronLeft className="size-3.5 shrink-0" aria-hidden />
          <span className="truncate">{props.project.name}</span>
        </Link>
        <h1 className="text-base font-semibold leading-snug [overflow-wrap:anywhere]">{publication.title}</h1>
        <PublicationByline publication={publication} copy={copy} compact />
      </div>
      {publication.access && <PublicationAccess key={publication.id} publication={publication} path={path} viewers={props.viewers} copy={copy} />}
    </header>
    {publication.pending && <p role="status" className="bg-muted px-5 py-2 text-sm">{copy.pending}</p>}
    {publication.error && <p role="alert" className="px-5 py-2 text-sm text-destructive">{publication.error}</p>}
    {denied ? <p role="alert" className="p-8">{copy.denied}</p> : publication.version
      ? <DashboardWorkbench key={publication.id} publication={publication} projectId={props.project.id} path={path} selectedView={props.selected_view} history={props.view_history} copy={copy} />
      : <p className="p-8 text-muted-foreground">{copy.unpublished}</p>}
  </main>
}
Show.layout = (page: React.ReactElement) => <DashboardLayout variant="fullscreen">{page}</DashboardLayout>
export default Show
